import { render, staticRenderFns } from "./Filial.vue?vue&type=template&id=541a61ca&"
import script from "./Filial.vue?vue&type=script&lang=ts&"
export * from "./Filial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports